// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__knTba","title":"AfterFrontImage_title__1s-fn"};